import { AuthService, AuthState } from '@ibe/services';

import { authService } from './Contexts';
import { authSession } from '../Boot/initAuth';
import jwtDecode from 'jwt-decode';

function useAuth(): {
  authState: AuthState;
  authService: AuthService;
  persistToken: () => void;
  removeToken: () => void;
  decodeToken: <T>() => T | null;
} {
  const persistToken = (): void => {
    if (authService.state.token) {
      authSession.set({ token: authService.state.token });
    } else {
      authSession.clear();
    }
  };

  const removeToken = (): void => {
    authSession.clear();
  };

  const decodeToken = <T>(): T | null => {
    return authService.state.token ? jwtDecode<T>(authService.state.token) : null;
  };

  return {
    authService,
    persistToken,
    removeToken,
    decodeToken,
    authState: authService.state
  };
}

export default useAuth;
